<template>
  <input-text v-bind="$attrs"
    ref="campo"
    v-model="model"
    prepend-inner-icon="event"
    v-mask="['##/##/####']"
    maxlength="10"
    format="datetext"
    type="tel"
    pattern="[0-9]*"
    v-on="$listeners"
    :max="max">
  <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
    <slot :name="slotName" v-bind="context" />
  </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
      <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}r</v-icon>
      <span v-html="message" :key="key"></span>
    </template>
  </input-text>
</template>

<script>
import { isValid, parseISO } from 'date-fns'
export default {
  props: {
    value: null,
    max: { type: [String, Date], default: () => new Date() },
  },
  data () {
    return {
    };
  },
  computed: {
    model: {
      get () {
        if (this.value && this.value.length >= 10 && this.value.split('-').length >= 3) {
          if (isValid(parseISO(this.value, 'yyyy-MM-dd'))) {
            return this.$api.UI.Format.Date(this.value)
          }
        }

        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  }
}
</script>
